import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';

export const STATUS_TABS = [
  { value: 'all', label: 'All' },
  { value: 'draft', label: 'Draft' },
  { value: 'sent', label: 'Sent' },
  { value: 'viewed', label: 'Viewed' },
  { value: 'signed', label: 'Signed' },
  { value: 'declined', label: 'Declined' },
  { value: 'expired', label: 'Expired' },
];

const ApprovalFilterTabs = ({ value, onChange }) => (
  <Box
    sx={{
      borderBottom: 1,
      borderColor: 'divider',
      position: 'sticky',
      top: 0,
      bgcolor: '#F6F7FB',
      zIndex: 2,
    }}
  >
    <Tabs
      value={value || 'all'}
      onChange={(_, v) => onChange(v)}
      variant="scrollable"
      scrollButtons={false}
      aria-label="Filter approvals by status"
      sx={{ minHeight: 40 }}
    >
      {STATUS_TABS.map((t) => (
        <Tab
          key={t.value}
          value={t.value}
          label={t.label}
          sx={{
            minHeight: 40,
            textTransform: 'none',
            fontSize: 13,
            fontWeight: 600,
          }}
        />
      ))}
    </Tabs>
  </Box>
);

export default ApprovalFilterTabs;
